import { AlertCircle } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** Pill-label в верхней строке (uppercase). По умолчанию — «Заметка». */
  label?: string;
}

/**
 * Note callout — стилистически идентичен `PlainExplanation` («По-человечески»):
 * border-l-2 + Lightbulb icon + uppercase pill-label + body. Используется
 * над CeoIntro для compliance-нот и приглашения к обратной связи.
 */
export function LegalNote({ children, label = 'Важно' }: Props) {
  return (
    <div role="note" className="my-8 flex gap-4 border-l-2 border-status-danger-text pl-4">
      <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-status-danger-text" aria-hidden />
      <div className="min-w-0 flex-1">
        <span className="mb-1 block text-xs font-semibold uppercase tracking-wider text-text-secondary">
          {label}
        </span>
        <div className="text-base leading-relaxed text-text-primary">{children}</div>
      </div>
    </div>
  );
}
